import Files from './Files'

export default Files